import { render, staticRenderFns } from "./system-message-page.html?vue&type=template&id=41e648a9&"
import script from "./system-message-page.ts?vue&type=script&lang=ts&"
export * from "./system-message-page.ts?vue&type=script&lang=ts&"
import style0 from "./system-message-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports